import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {  DialogService } from 'ng2-bootstrap-modal';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';
import { CustomerService } from '../_services/customer.service';
import { OPCOVIEWLABELS, SEARCHVIEWLABELS, SHAREDCONSTANTS, APIURLS } from '../_constants/constants';
import { AgentProfileService } from '../_services/agent.profile.service';
import { SearchService } from '../_services/search.service';
import { environment } from '../../environments/environment';

import { NotificationDialogComponent } from './../notification/notification.dialog.component';

import { DeleteCofirmationDialogComponent } from '../shared/delete-confirmation/delete-confirmation.dialog.component';
import { TranslatePipe } from '../shared/translate/translate.pipe';
import { Address, getUpdatePersonFromDetails, PersonDetails, PersonDetailsUpdate } from '../_models/data.structures';
import { TranslateService } from '../_services/translate.service';

import { LoaderService } from '../_services/loader.service';





@Component({
  templateUrl: './search-form.component.html',
  providers: [SearchService, TranslatePipe]
})

export class SearchFormComponent implements  OnInit {
  router: Router;
  ds: DialogService;
  opcoValue: string;
  searchValue: string;
  dropValue: string;
  selectedCountry:string = '';
  verifiedOnly: boolean;
  activeOnly: boolean;
  opcoviewlabels = OPCOVIEWLABELS;
  searchviewlabels = SEARCHVIEWLABELS;
  sharedconstantlabels = SHAREDCONSTANTS;
  agentProfileService: AgentProfileService;
  searchService: SearchService;
  customerService: CustomerService;
  previousData: PersonDetails;
  page: number = 1;
  totalItems: number;
  customers: any = [];
  expandedPhones: any = {};
  expandedEmails: any = {};
  options: any = [];
  itemsPerPage : number = 10;
  isLoading:Boolean = false;
  offset:number = 0;
  recordStart:number = 0;
  status:string = "all";
  recordEnd:number;
  currentPageItemsLength:number;
  person: PersonDetailsUpdate;
  deleteConfirmation:boolean = false;
  fromDelete:boolean = false;
  _search:any;
  _subscription:any;
  requiredErrorMsg:string = "";
  letterError: Boolean = false;
  numberError: Boolean = false;
  charLengthError: Boolean = false;
  changeDropValue:Boolean=true;

  constructor(router: Router,
    ds: DialogService,
    private http: Http,
    private route: ActivatedRoute,
    searchService: SearchService,
    agentProfileService: AgentProfileService,
    private translatePipe: TranslatePipe,
    private translateService: TranslateService,
    private loaderService: LoaderService) {
    this.router = router;
    this.ds = ds;
    this.agentProfileService = agentProfileService;
    this.searchService = searchService;
    this._search = searchService.search;
    this._subscription = searchService.nameChange.subscribe((value) => {
      this._search = value;
    });


  }

  ngOnDestroy() {
   //prevent memory leak when component destroyed
    this._subscription.unsubscribe();
  }

  setCustomValidity(event){
    event.target.setCustomValidity(this.translatePipe.transform("REQUIRED_FIELD",'CLIENT_SIDE_VALIDATION_ERROR'));
  }

  setCustomValidityBlank(event){
    event.target.setCustomValidity('');
  }

  mouseHover(event){
    this.changeDropValue=true;
    event.target.setAttribute("title", "");

    // if (event.target.value == ""){
    //   event.target.setAttribute("title", this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR'))
    // }
    // else{
    //   event.target.setAttribute("title", "")
    // }
  }

  ngOnInit(): void {
      this.letterError = false;
      this.fromDelete = false;
      this.requiredErrorMsg = this.translatePipe.transform("REQUIRED_FIELD",'CLIENT_SIDE_VALIDATION_ERROR');
      this.dropValue = "email";
      this.route.params.subscribe(params => {
      this.opcoValue = params['opco'];
      this.selectedCountry = params['country'];

      if ((localStorage.getItem('opco') && localStorage.getItem('opco') != params['opco']) || (localStorage.getItem('country') && localStorage.getItem('country') != params['country'])) {
        this.router.navigate(['/']);
      }

    });

    let searchData = JSON.parse(localStorage.getItem('searchData'));
    console.log(this.opcoValue);
    if(this.opcoValue === 'ro' || this.opcoValue === 'vo' || this.opcoValue === 'al' || this.opcoValue === 'cz' || this.opcoValue === 'it'){
      if(Object.keys(searchData).length !== 0){
        if(searchData.hasOwnProperty('type')){
            this.dropValue = (searchData['type']);
        }
      }
    }

    const opco = this.opcoValue.toUpperCase();

    const searchParameter = this.agentProfileService.loadAgentProfile().supportedSearchParameter;

    const options = searchParameter[opco];
    if (options) {
      Object.keys(options).forEach((key) => {
        this.options.push({
          value: key.trim(),
          name: (options[key] as string).trim(),
        });
      });
    } else {
      console.warn('No search options found for opco:', opco);
    }

    if(Object.keys(searchData).length !== 0){
      if(searchData.hasOwnProperty('opco')){
        this.opcoValue = searchData['opco']
      }
      if(searchData.hasOwnProperty('searchStr')){
        this.searchValue = searchData['searchStr']
      }
      if(searchData.hasOwnProperty('verified') && searchData.hasOwnProperty('verified') === true){
        this.verifiedOnly = searchData['verified']
      }
      if(searchData.hasOwnProperty('country')){
        this.selectedCountry = searchData['country']
      }

      this.getCustomerData(searchData['page']);

    }
  }

  searchButtonPressed(formData: any) {


    this.getCustomerData(1, formData);
    //this.searchService.getDataForList(this.searchValue, this.verifiedOnly, this.opcoValue, this.ds);
  }

  detailsButtonPressed(sub: string) {

    if(this.selectedCountry === "" || typeof this.selectedCountry === "undefined"){
        this.router.navigate(['/' + this.opcoValue + '/details/' + sub]);
    }
    else{
      this.router.navigate(['/' + this.opcoValue + '/details/' + sub + "/country/"+this.selectedCountry]);
    }

  }

  deleteButtonPressed(sub: string, etag: string, environment) {

    event.stopPropagation();
    document.getElementById("deleteButtonId").blur();

    this.ds.addDialog(DeleteCofirmationDialogComponent, {
      title:this.translatePipe.transform("CONFIRMATION_TITLE",'SEARCHVIEWLABELS'),
      message:this.translatePipe.transform("CONFIRMATION_MESSAGE",'SEARCHVIEWLABELS'),
      okButtonLabel:this.translatePipe.transform("OK_BUTTON_LABEL",'SHAREDCONSTANTS'),
      cancelButtonLabel:this.translatePipe.transform("CANCEL_BUTTON_LABEL",'SHAREDCONSTANTS')})
      .subscribe((isConfirmed)=>{
        //Get dialog result
        this.deleteConfirmation = isConfirmed;

        if(this.deleteConfirmation){
          this.loaderService.display(true);
          this.fromDelete = true;
          //this.searchService.deleteSub(sub, this.opcoValue, this.ds);
          if(this.opcoValue === 'ro'|| this.opcoValue === 'vo' || this.opcoValue === 'al' || this.opcoValue === 'cz' || this.opcoValue === 'it'){
         //    this.previousData.status = "DELETED";
          //  this.person = getUpdatePersonFromDetails(this.previousData);
       //   this.customerService.saveUpdatedUser(this.person, sub, this.opcoValue, this.ds);
            console.log('deleting user from searchService.saveUpdatedUser patch call'); 
            this.saveUpdatedUserSearchPage(sub,this.opcoValue,etag);
            //  this.loaderService.display(false);
            //  this.page = (this.currentPageItemsLength == 1 && this.page!=1) ? this.page - 1 : this.page;

            //  this.getCustomerData(this.page);
          }


          else{

            this.searchService.deleteCustomer(sub, this.opcoValue, this.ds).subscribe(
              (data) => {

                console.log('deleting user from searchService.deleteCustomer call'); 
                if(data.status === 200){

                 // this.getCustomerData(this.page);
                }
                else{
                  if(this.translateService.checkAPIErrorExistsByCode(data.json().internalCode)){

                  }
                }
                this.loaderService.display(false);

                this.page = (this.currentPageItemsLength == 1 && this.page!=1) ? this.page - 1 : this.page;

                this.getCustomerData(this.page);

              },
              (err) => {

                  if(this.translateService.checkAPIErrorExistsByCode(err.json().internalCode)){

                  }
                  else{

                  }
                  this.loaderService.display(false);
                  this.page = (this.currentPageItemsLength == 1 && this.page!=1) ? this.page - 1 : this.page;

                  this.getCustomerData(this.page);

                }

                );

          }

       

        }
    });

  }

  saveUpdatedUserSearchPage( subValue: string, opcoValue: string,etagValue: string ) {
    console.log('deleting user from new function saveUpdatedUserSearchPage');
    let URL;
    let payload;
    if(opcoValue == 'ro') {
        payload ="{\"status\":\"DELETED\"}";
        URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Ro).replace('{sub}',subValue);
    }
    else if(opcoValue == 'vo') {
        payload ="{\"status\":\"TERMINATED\"}";
        URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Vo).replace('{sub}',subValue);
    }
    else if(opcoValue == 'al') {
        payload ="{\"status\":\"DELETED\"}";
        URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Al).replace('{sub}',subValue);
    }
    else if(opcoValue == 'cz') {
        payload ="{\"status\":\"DELETED\"}";
        URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Cz).replace('{sub}',subValue);
    }
    else if(opcoValue == 'it') {
      payload ="{\"status\":\"DELETED\"}";
      URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_It).replace('{sub}',subValue);
  }
    
    const headers = new Headers();
    headers.append('x-int-opco-id', opcoValue);
    headers.append('Content-Type', 'application/merge-patch+json');
    headers.append('If-None-Match', etagValue);
    headers.append('external-user', this.agentProfileService.loadAgentProfile().email);
    const options = new RequestOptions({ headers: headers, withCredentials: true });
    console.log("Save date: " + payload);
    this.http.patch(URL, payload, options).subscribe(
        response => {
            //DetailsComponent.decrementRunningRequests();
            console.log("delete from saveUpdatedUserSearchPage page is successful")
            this.loaderService.display(false);
            this.page = (this.currentPageItemsLength == 1 && this.page!=1) ? this.page - 1 : this.page;
            this.getCustomerData(this.page);

        },
        err => {

             console.log(err);
        },
        () => {
            setTimeout(()=> {


            }, 1000);

        }
    );

  }
  prevButtonPressed() {
    this.searchService.getDataForLink(this.searchService.getLookUpResult().links.previous.href, this.opcoValue, this.ds);
  }

  nextButtonPressed() {
    this.searchService.getDataForLink(this.searchService.getLookUpResult().links.next.href, this.opcoValue, this.ds);
  }

  disableLetterError(evt){
    this.changeDropValue=true;
    if (evt.which === 32)
      evt.preventDefault();

    this.letterError = false;
    this.charLengthError=false;
  }

  onBlurHandler(evt) {
    this.searchValue = this.searchValue.trim();
  }
  
  onKeyUp(evt){
    this.changeDropValue=true;
    this.charLengthError = (parseInt(evt.target.value.length) === 1 && evt.target.value !== "*") ? true : false;
  }

  onChangeHandler(evt) {
    this.changeDropValue=true;
    this.charLengthError = (parseInt(evt.target.value.length) === 1 && evt.target.value !== "*") ? true : false;
  }


  onChangedropValue(evt){
    this.changeDropValue=false;
    this.searchValue=''; 
    this.activeOnly=false;
    this.customers= [];
    this.letterError=false;
    this.charLengthError=false;
  }

  getCustomerData(event, formData?:any) {
    this.letterError = false;
    this.numberError = false;
    /**
     * To fix search result when clicking on pagination results.
     */
    if (!formData) {
      let searchData = JSON.parse(localStorage.getItem('searchData'));
      this.searchValue = searchData['searchStr'];
    }
    /************************* */

    if(this.dropValue === 'username' && (this.opcoValue === 'ro' || this.opcoValue === 'vo')) {
      this.letterError = false;
    }

    if (this.searchValue === undefined || this.searchValue == null || this.searchValue.trim() == "") {

      formData.form.controls['searchInput'].markAsDirty();
      formData.form.controls['searchInput'].markAsTouched();
      formData.form.controls['searchInput'].setErrors({ 'required': true });

      // formData.form.controls['searchInput'].setErrors({ 'invalid': true });
      // formData.form.controls['searchInput'].setErrors({ 'required': true });
      return;
    }

    if (this.searchValue.length < 2 && !(/^\*{1,2}$/).test(this.searchValue)) {
      return;
    }


    if(this.opcoValue === 'ro' || this.opcoValue === 'vo' || this.opcoValue === 'al' || this.opcoValue === 'cz' || this.opcoValue === 'it')
    {
        // This is for RO only
        if (this.dropValue === "msisdn" && this.searchValue != "" && (/^[0-9]*$/).test(this.searchValue) === true && this.searchValue.length >=5) {
          //if ((/^[0-9]+$/).test(this.searchValue) === true && this.searchValue.length < 5) {
              ///this.numberError = true;


        }
          else if (this.dropValue === "email" && this.searchValue != "" && (/^[^@]+([+\.-][^@]+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(this.searchValue)) {
            
          }
          else if ((this.dropValue !== 'email' && this.dropValue !== 'msisdn' ) && (!this.searchValue.includes('*'))) {
            
          }
          else {
           
            this.letterError = true;

            // let lastSearchData = JSON.parse(localStorage.getItem('searchData'));

            // if (Object.keys(lastSearchData).length !== 0) {

            //   if (lastSearchData.hasOwnProperty('searchStr')) {
            //     this.searchValue = lastSearchData['searchStr'];
            //   }
            // }

          return;
          }
    }
    else{

    if (this.searchValue != "" && ((/^[0-9]+$/).test(this.searchValue) || (/^[0-9]+\*$/).test(this.searchValue) || (/^\*[0-9]+$/).test(this.searchValue) || (/^\*[0-9]*\*+$/).test(this.searchValue)|| (/^\*+$/).test(this.searchValue))) {

      if ((/^[0-9]+$/).test(this.searchValue) === true && this.searchValue.length < 5) {

      }

    } else if (this.searchValue != "" && (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.searchValue) || /^[a-zA-Z0-9_.-]*$/.test(this.searchValue) || /^[a-zA-Z0-9_.-]*\*$/.test(this.searchValue) || /^\*[a-zA-Z0-9_.-]*\*$/.test(this.searchValue) || /^\*[a-zA-Z0-9_.-]*$/.test(this.searchValue)) && (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.searchValue))) {


    } else {

      this.letterError = true;
    

      // let lastSearchData = JSON.parse(localStorage.getItem('searchData'));

      // if (Object.keys(lastSearchData).length !== 0) {

      //   if (lastSearchData.hasOwnProperty('searchStr')) {
      //     this.searchValue = lastSearchData['searchStr'];
      //   }
      // }

      return;
    }

  }

    this.loaderService.display(true);

    if(document.getElementById("searchInput") !== null && document.getElementById("searchSubmitButtonId") !== null){
      document.getElementById("searchInput").blur();
      document.getElementById("searchSubmitButtonId").blur();
    }


    this.isLoading = true;
    this.offset = (event - 1) * this.itemsPerPage;

      this.searchService.getCustomersData(event,this.searchValue, this.dropValue, this.verifiedOnly, this.activeOnly, this.opcoValue, this.selectedCountry, this.ds, this.itemsPerPage, this.offset, this.status).subscribe(

        (data) => {
          this.page = event;
          this.customers = data.items,
          this.totalItems = data.totalItems,
          this.isLoading = false,
          this.recordStart = (this.offset) + 1;

          if(this.opcoValue === 'ro'){
            let tempRecordEnd = this.offset + this.itemsPerPage;
            if(tempRecordEnd < this.totalItems){
              this.recordEnd = this.offset + this.itemsPerPage;
            }else{
              this.recordEnd = this.totalItems;
            }

          }else{
            this.recordEnd = (this.offset + this.itemsPerPage) - (this.itemsPerPage - parseInt(this.customers.length));
          }

          this.currentPageItemsLength = this.customers.length;

          localStorage.setItem('searchData', JSON.stringify({ opco: this.opcoValue, country: this.selectedCountry, verified:this.verifiedOnly,page:this.page, searchStr: this.searchValue, type: this.dropValue}));

          this.loaderService.display(false);

        },
        (err) => {
                  this.loaderService.display(false);
                  this.isLoading = false;


                  if(this.translateService.checkAPIErrorExistsByCode(err.json().internalCode)){
                  //   if(err.json().internalCode === "RO_PHONE_NUMBER_NOT_VALID"){
                  //     this.letterError = true;

                  //  }
                  //  else{
                      this.ds.addDialog(NotificationDialogComponent, {
                          success: false,
                          message: this.translatePipe.transform(err.json().internalCode,'API_ERROR')
                      });

                      if(err.json().internalCode === "NOT_FOUND" || err.json().internalCode === "RO_EMAIL_ID_NOT_VALID" || err.json().internalCode === "RO_PHONE_NUMBER_NOT_VALID" || err.json().internalCode === "RO_CONTACT_ID_NOT_VALID"){
                        this.customers = [];
                      }
                // }
                  }
                  else if(err.status === 404){
                    if(!this.fromDelete){
                      this.ds.addDialog(NotificationDialogComponent, {
                          success: false,
                          message: this.translatePipe.transform("NO_DATA_FOUND_ERROR",'SEARCHVIEWLABELS')
                      });
                    }

                    this.fromDelete = false;
                    this.customers = [];
                  }
                  else if(err.status === 400){
                    if(!this.fromDelete){
                      this.ds.addDialog(NotificationDialogComponent, {
                          success: false,
                          message: err.json().message
                      });
                    }

                    this.fromDelete = false;
                    this.customers = [];
                  }
                  else if(err.status === 401){
                      window.location.href = '/';
                  }
                  else{
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: this.translatePipe.transform("COMMON_ERROR_MESSAGE",'SHAREDCONSTANTS')
                    });
                  }
              },
              () => {
                  this.isLoading = false;
                  this.loaderService.display(false);
                  if(this._search && this._search!==""){
                    this.searchValue = this._search;
                    this._search = "";
                  }
              }
      );

    return event;
  }

  togglePhones(sub: string) {
    this.expandedPhones[sub] = !this.expandedPhones[sub];
    // Trigger margin calculation after DOM update
    if (this.expandedPhones[sub]) {
      setTimeout(() => this.calculatePhoneVerifiedMargin(sub), 0);
    }
  }

  isExpandedPhone(sub: string): boolean {
    return !!this.expandedPhones[sub];
  }

  getPhoneVerifiedMargin(sub: string): string {
    return this.calculatePhoneVerifiedMargin(sub);
  }

  calculatePhoneVerifiedMargin(sub: string): string {
    try {
      const boxPhone = document.getElementById('box-phone-' + sub);
      const recoveryHeading = document.getElementById('recovery-heading-' + sub);
      
      if (boxPhone && recoveryHeading) {
        const boxPhoneRect = boxPhone.getBoundingClientRect();
        const recoveryHeadingRect = recoveryHeading.getBoundingClientRect();
        
        // Calculate the distance from top of box-phone to top of recovery-heading
        const distance = recoveryHeadingRect.top - boxPhoneRect.top - 2;
        
        // Return the calculated margin
        return distance + 'px';
      }
    } catch (e) {
      // Fallback to default margin if calculation fails
      console.error('Error calculating phone verified margin:', e);
    }
    
    // Default fallback margin
    return '52px';
  }

  toggleEmails(sub: string) {
    this.expandedEmails[sub] = !this.expandedEmails[sub];
    // Trigger margin calculation after DOM update
    if (this.expandedEmails[sub]) {
      setTimeout(() => this.calculateEmailVerifiedMargin(sub), 0);
    }
  }

  isExpandedEmail(sub: string): boolean {
    return !!this.expandedEmails[sub];
  }

  getEmailVerifiedMargin(sub: string): string {
    return this.calculateEmailVerifiedMargin(sub);
  }

  calculateEmailVerifiedMargin(sub: string): string {
    try {
      const boxEmail = document.getElementById('box-email-' + sub);
      const recoveryEmailHeading = document.getElementById('recovery-email-heading-' + sub);
      
      if (boxEmail && recoveryEmailHeading) {
        const boxEmailRect = boxEmail.getBoundingClientRect();
        const recoveryEmailHeadingRect = recoveryEmailHeading.getBoundingClientRect();
        
        // Calculate the distance from top of box-email to top of recovery-email-heading
        const distance = recoveryEmailHeadingRect.top - boxEmailRect.top - 2;
        
        // Return the calculated margin
        return distance + 'px';
      }
    } catch (e) {
      // Fallback to default margin if calculation fails
      console.error('Error calculating email verified margin:', e);
    }
    
    // Default fallback margin
    return '52px';
  }

}



// WEBPACK FOOTER //
// ./src/app/search/search-form.component.ts